import { Col } from "react-bootstrap"
import css from "./styles.module.css"
import { useDispatch, useSelector } from "react-redux"
import dayjs from "dayjs"
import { DocumentoStatus, ListaUsuarioAssinaturas } from "../pendentes/PainelDocumentosPendentes"
import { getDocumentosReqPost } from "./DocumentosFuncoes"
import { atualizar, loadingPasta, selecionarDocumento, selecionarPasta } from "../documentosSlice"

export default function ListaPastasDocumentos() {
    const documentos:any[] = useSelector((state:any) => state.uiDocumentos.documentos)
    const pastas:any[] = useSelector((state:any) => state.uiDocumentos.pastas)

    if (pastas.length === 0 && documentos.length === 0) {
        return (
            <div>
                <p style={{textAlign: "center"}}>Pasta vazia.</p>
            </div>
        )
    }
    
    return (
        <div id={css.div_arquivos}>
            <div id={css.div_arquivos_border}>
                <ListaPastas pastas={pastas} />
                <ListaDocumentos documentos={documentos} />
            </div>
        </div>
    )
}

function ListaPastas({ pastas }:iPropsPastas) {
    const dispatch = useDispatch()
    const cssPastaIcon:React.CSSProperties = {
        display: "flex",
        alignItems: "center"
    }

    async function handleClickPasta(mouseClick: number, id_pasta: number) {
        const link = `/documentos/todos?pasta=${id_pasta}`
        if (mouseClick === 0) {
            window.history.pushState("OB PORTUS .NET", "OB PORTUS DOCUMENTOS", link)
            dispatch(loadingPasta({status: true}))
            const api = await getDocumentosReqPost(id_pasta)
            dispatch(loadingPasta({status: false}))
            if (api.status === 200) {
                dispatch(atualizar(api.data))
            }
        }
        if (mouseClick === 1) {
            window.open(link)
        }
    }

    return (
        <div>
            {
                pastas.map((pasta, idx, dados) => {
                    return (
                        <div key={idx} className={css.div_pastas} onClick={async (event) => {
                            const target:any = event.target
                            if (target.localName === "input") {
                                return
                            }
                            event.preventDefault()
                            event.stopPropagation()
                            handleClickPasta(event.button, pasta.id_pasta)
                        }} onMouseUp={(event) => {
                            const target:any = event.target
                            if (target.localName === "input") {
                                return
                            }
                            event.preventDefault()
                            event.stopPropagation()
                            handleClickPasta(event.button, pasta.id_pasta)
                        }} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>
                            <div className="div-row">
                                <Col className="col-7" style={cssPastaIcon}>
                                    <input className={css.arquivo_checkbox} id={`check_pasta_${pasta.id_pasta}`} type="checkbox" onChange={(event) => {
                                        const target:any = event.target
                                        dispatch(selecionarPasta({id_pasta: pasta.id_pasta, ativo: target.checked}))
                                    }} checked={pasta.selecionado === undefined ? false : pasta.selecionado} />
                                    <span className="material-symbols-outlined" style={{marginRight: "10px"}}>
                                        folder
                                    </span>
                                    <p className={css.arquivo_name}>{pasta.nome}</p>
                                </Col>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
interface iPropsPastas {
    pastas: any[]
}

function ListaDocumentos({ documentos }:iPropsDocumentos) {
    const dispatch = useDispatch()
    const cssDocumentoIcon:React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px"
    }

    function handleClickDocumento(mouseClick: number, codigo: string) {
        const link = `/documento?id=${codigo}`
        if (mouseClick === 0) {
            window.location.assign(link)
        }
        if (mouseClick === 1) {
            window.open(link)
        }
    }

    return (
        <div>
            {
                documentos.map((documento, idx, dados) => {
                    let data_assinado = <span></span>
                    if (documento.data_assinado !== null) {
                        data_assinado = <span className={css.documento_data_finalizado}>Finalizado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}</span>
                    }
                    let documento_local = <span></span>
                    if (String(documento.original_caminho).search("local") > 0) { 
                        documento_local = <span className={css.documento_data_finalizado}>HOMOLOGAÇÃO DEV</span>
                    }
                    return (
                        <div key={idx} className={css.div_documentos} onClick={(event) => {
                            console.log(event)
                            const target:any = event.target
                            if (target.localName === "input") {
                                return
                            }
                            event.preventDefault()
                            event.stopPropagation()
                            handleClickDocumento(event.button, documento.codigo)
                            // window.location.href = `/documento?id=${documento.codigo}`
                        }} onMouseUp={(event) => {
                            console.log(event)
                            const target:any = event.target
                            if (target.localName === "input") {
                                return
                            }
                            event.preventDefault()
                            event.stopPropagation()
                            handleClickDocumento(event.button, documento.codigo)
                        }} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>
                            <div className="div-row">
                                <Col className="col-7">
                                    <div style={cssDocumentoIcon}>
                                        <input className={css.arquivo_checkbox} id={`check_pasta_${documento.id_pasta}`} type="checkbox" onChange={(event) => {
                                            const target:any = event.target
                                            dispatch(selecionarDocumento({codigo: documento.codigo, ativo: target.checked}))
                                        }} checked={documento.selecionado === undefined ? false : documento.selecionado} />
                                        <span className="material-symbols-outlined" style={{marginRight: "10px", color: "#0d6efd"}}>
                                            draft
                                        </span>
                                        <p className={css.arquivo_name}>{documento.nome}</p>
                                        {documento_local}
                                    </div>
                                    <p className={css.documento_criacao}>#{documento.id} Criado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}{data_assinado}</p>
                                    { documento.id_usuario !== null && <p className={css.documento_nome_usuario}>Por {documento.id_usuario.nome}</p> }
                                    
                                </Col>
                                <Col className="col-3">
                                    <p>Assinaturas</p>
                                    <ListaUsuarioAssinaturas assinaturas={documento.signatarios} />
                                </Col>
                                <Col className="col-2" style={{display: "flex", justifyContent: "end"}}>
                                    <DocumentoStatus id_status={documento.id_status.id_status} status={documento.id_status.descricao} lixeira={0} />
                                </Col>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
interface iPropsDocumentos {
    documentos: any[]
}
